import { Collection } from '@/resource/collection/collection.model';
import {
  PreCollection,
  PreCollectionThumbnail,
  PreCollectionType,
} from '@/resource/pre-collection/pre-collection.model';
import { axios } from '@/utils/axios';
export interface CreatePreCollectionParam {
  name: string;
  description: string;
  details: string;
  type: PreCollectionType;
  thumbnail: PreCollectionThumbnail;
  form: number;
  year: number;
  subjectUuid: string;
  pdfLink: string;
  pdfLinkPreview: string;
  isPremium: boolean;
  isDraft: boolean;
  collectionUuid: string;
  totalQuestions: number | null;
}

export interface UpdatePreCollectionParam extends CreatePreCollectionParam {}

export async function getAllPreCollections(): Promise<PreCollection[]> {
  const { data } = await axios.get('pre-collections/all');
  return data;
}

export async function createPreCollection(
  params: CreatePreCollectionParam,
): Promise<PreCollection> {
  const { data } = await axios.post('pre-collections', params);
  return data;
}

export async function getPreCollectionByUuid(
  uuid: string,
): Promise<PreCollection> {
  const { data } = await axios.get(`pre-collections/${uuid}`);
  return data;
}

export async function getPreCollectionByUuidWithUser(
  uuid: string,
): Promise<PreCollection> {
  const { data } = await axios.get(`pre-collections/${uuid}/user`);
  return data;
}

export async function copyPreCollectionByUuid(
  uuid: string,
): Promise<Collection> {
  const { data } = await axios.post(`pre-collections/${uuid}/copy`);
  return data;
}

export async function updatePreCollectionByUuid(
  uuid: string,
  params: UpdatePreCollectionParam,
): Promise<PreCollection> {
  const { data } = await axios.put(`pre-collections/${uuid}`, params);
  return data;
}

export async function deletePreCollectionByUuid(uuid: string) {
  await axios.delete(`pre-collections/${uuid}`);
}
